import * as React from 'react';

import styles from './ImageAsDocumentMessageLayout.css';
import { EMessageType } from '../../../../types/messageType';
import { EUserColor } from '../../../../types/userName';
import { ChatMessageBubble } from '../../../ChatMessageBubble';
import { ChatMessage } from '../../../ChatMessage';
import { MetaRow } from '../MetaRow';

interface IImageAsDocumentMessageLayoutProps {
  errorSign: React.ReactNode;
  errorText: React.ReactNode;
  messageType: EMessageType;
  isLastMessageInChain: boolean;
  imageAsDocumentMessage: React.ReactNode;
  messageMeta: React.ReactNode;
  userColor?: EUserColor;
  replyQuote?: React.ReactNode | null;
  highlighted?: boolean;
  onHighlightEnd?: VoidFunction;
}

export const ImageAsDocumentMessageLayout = React.forwardRef<HTMLDivElement, IImageAsDocumentMessageLayoutProps>(
  function ImageAsDocumentMessageLayout(
    {
      errorSign,
      errorText,
      messageType,
      isLastMessageInChain,
      imageAsDocumentMessage,
      messageMeta,
      userColor,
      replyQuote,
      highlighted,
      onHighlightEnd,
    },
    ref,
  ) {
    return (
      <ChatMessage errorSign={errorSign} errorText={errorText}>
        <ChatMessageBubble
          messageType={messageType}
          withTail={isLastMessageInChain}
          className={styles['image-as-document-message__bubble']}
          ref={ref}
          userColor={userColor}
          highlighted={highlighted}
          onHighlightEnd={onHighlightEnd}
        >
          {replyQuote}
          {imageAsDocumentMessage}
          <MetaRow
            messageType={messageType}
            className={styles['image-as-document-message__meta']}
            userColor={userColor}
          >
            {messageMeta}
          </MetaRow>
        </ChatMessageBubble>
      </ChatMessage>
    );
  },
);
